import React from "react";
import { Helmet } from "react-helmet";

const PageHeader = ({ headerText, children }) => {
  return (
    <div className="container-fluid">
      <Helmet>
        <title>Sierra - {headerText}</title>
      </Helmet>
      <div className="row">
        <div className="col-xs-12">
          <h1>{headerText}</h1>
          <hr />
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageHeader;
